import React, { useState } from "react";
import { CollectionDesignation, SortingBy } from "../../../../common/interfaces";
import "./sorting-dropdown.scss";

export interface SortingDropdownProps {
  onSelected: (selectedOrder: SortingBy) => void;
  value: SortingBy;
  collectionDesignation: CollectionDesignation;
}

function getSortingOrderLabels(designation: CollectionDesignation) {
  switch (designation) {
    case CollectionDesignation.Subscription:
      return {
        [SortingBy.Newest]: "Newest",
        [SortingBy.Featured]: "Featured",
      };
    case CollectionDesignation.AvailableToBuy:
      return {
        [SortingBy.Newest]: "Newest",
        [SortingBy.Featured]: "Featured",
        [SortingBy.LowestPrice]: "Lowest Price",
        [SortingBy.HighestPrice]: "Highest Price",
      };
    case CollectionDesignation.OnDemand:
    case CollectionDesignation.All:
    default:
      return {
        [SortingBy.Newest]: "Newest",
        [SortingBy.Featured]: "Featured",
        [SortingBy.LowestPrice]: "Lowest Rental Price",
        [SortingBy.HighestPrice]: "Highest Rental Price",
      };
  }
}

export const SortingDropdown: React.FC<SortingDropdownProps> = ({ onSelected, value, collectionDesignation }) => {
  const [open, setOpen] = useState(false);
  const sortingOrderLabels = getSortingOrderLabels(collectionDesignation);
  const selectedOrderLabel = sortingOrderLabels[value];

  return (
    <div className="c-sorting-dropdown">
      <div className="c-sorting-dropdown__header" onClick={() => setOpen(!open)}>
        <h4 className="c-sorting-dropdown__label">{selectedOrderLabel}</h4>
        <img
          src={require("../../../../../assets/chevron-down.svg")}
          className={`c-sorting-dropdown__chevron ${open ? "c-sorting-dropdown__chevron--open" : ""}`}
          alt="chevron down"
        />
      </div>
      <ul className="c-sorting-dropdown__options" data-open={open}>
        {Object.keys(sortingOrderLabels).map((key: SortingBy) => (
          <li
            key={key}
            onClick={() => {
              onSelected(key);
              setOpen(false);
            }}
          >
            {sortingOrderLabels[key]}
          </li>
        ))}
      </ul>
    </div>
  );
};
